export  function groupBy<T>(items: Array<T>,
  key: (current: T) => string,
  comparator: (current: T, key: string) => boolean) {

  let grouped = new Map<string, T[]>();
  items.forEach((com, _, arr) => {
    const k = key(com);
    if (comparator(com, k)) {
      grouped.set(k, (grouped?.get(k) ?? []).concat(com))
    }
  })
  return grouped;
};